import React from 'react'
import { FaQrcode } from 'react-icons/fa'
import { Box, SimplePopover, Button, Icon } from '@/components/lib'
import QrCode from './QrCode'

export default function QrPopover ({ trigger, name, url, size }) {
  return (
    <SimplePopover
      trigger={trigger || <Button size={size}><Icon as={FaQrcode} /></Button>}
      header='QR Code'
      body={
        <Box>
          <QrCode name={name} url={url} size={size} withDownload />
        </Box>
      }
    />
  )
}
